export const getBearerToken = () => {
  let bearerToken = localStorage.getItem("bearerToken");
  if (bearerToken !== null && bearerToken !== "null") {
    return { isServerLoggedIn: true, bearerToken };
  } else {
    return { isServerLoggedIn: false, bearerToken: "" };
  }
};

export const getXAuthToken = () => {
  let xAuthToken = localStorage.getItem("xAuthToken");
  if (xAuthToken !== null && xAuthToken !== "null") {
    return { isNodeLoggedIn: true, xAuthToken };
  } else {
    return { isNodeLoggedIn: false, xAuthToken: "" };
  }
};

export const getSuperBabyXAuthToken = () => {
  let superBabyXAuthToken = localStorage.getItem("superBabyXAuthToken");
  if (superBabyXAuthToken !== null && superBabyXAuthToken !== "null") {
    return { isSuperBabyNodeLoggedIn: true, superBabyXAuthToken };
  } else {
    return { isSuperBabyNodeLoggedIn: false, superBabyXAuthToken: "" };
  }
};

export const getAllTokens = () => {
  let bearerToken = localStorage.getItem("bearerToken");
  let xAuthToken = localStorage.getItem("xAuthToken");
  let superBabyXAuthToken = localStorage.getItem("superBabyXAuthToken");
  let isServerLoggedIn = false;
  let isNodeLoggedIn = false;
  let isSuperBabyNodeLoggedIn = false;

  if (bearerToken !== null && bearerToken !== "null") {
    isServerLoggedIn = true;
  }
  if (xAuthToken !== null && xAuthToken !== "null") {
    isNodeLoggedIn = true;
  }

  if (superBabyXAuthToken !== null && superBabyXAuthToken !== "null") {
    isSuperBabyNodeLoggedIn = true;
  }

  return {
    isServerLoggedIn,
    bearerToken,
    isNodeLoggedIn,
    xAuthToken,
    isSuperBabyNodeLoggedIn,
    superBabyXAuthToken,
  };
};

export const Auth = {
  isServerLoggedIn: false,
  isNodeLoggedIn: false,
  bearerToken: "",
  xAuthToken: "",
  superBabyXAuthToken: "",
  authenticateServerData(AuthToken) {
    this.isServerLoggedIn = true;
    window.localStorage.setItem("bearerToken", AuthToken);
    this.bearerToken = AuthToken;
  },
  signOutServer() {
    this.isServerLoggedIn = true;
    window.localStorage.setItem("bearerToken", null);
    this.bearerToken = null;
  },
  authenticateNodeData(AuthToken) {
    this.isNodeLoggedIn = true;
    window.localStorage.setItem("xAuthToken", AuthToken);
    this.xAuthToken = AuthToken;
  },
  signOutNode() {
    this.isNodeLoggedIn = true;
    window.localStorage.setItem("xAuthToken", null);
    this.xAuthToken = null;
  },
  authenticateSuperBabyNodeData(AuthToken) {
    this.isSuperBabyNodeLoggedIn = true;
    window.localStorage.setItem("superBabyXAuthToken", AuthToken);
    this.superBabyXAuthToken = AuthToken;
  },
  signOutSuperBabyNode() {
    this.isSuperBabyNodeLoggedIn = true;
    window.localStorage.setItem("superBabyXAuthToken", null);
    this.superBabyXAuthToken = null;
  },
};
